import { DuotoneIcon, DuotoneIconProps } from './DuotoneIcon';

export function UsersIcon(props: Omit<DuotoneIconProps, 'name'> & { name?: DuotoneIconProps['name'] }) {
  return <DuotoneIcon name="users-gear" {...props} />;
}
